export const SSN_REGEX = /^\d{3}-\d{2}-\d{4}$/;
export const SSN_MASKED_REGEX = /^\*{3}-\*{2}-\*{4}$/;
export const ZIP_CODE_REGEX = /^\d{5}(-?\d{4})?$/;
